import type { useNavigate } from 'react-router-dom';

/**
 * Navigate to a server-supplied URL using React Router rather than the
 * browser's native navigation.
 *
 * Notification rows, push payloads, and HTML5 Notification onclick all carry
 * absolute URLs (e.g. `https://desktop.underlings.com/gatherings/X?rsvp=Y`)
 * because the same payload has to work across surfaces (email, web push,
 * native push). Passing those straight to React Router's `navigate()`
 * triggers a real cross-origin navigation — and inside the Capacitor
 * WebView the cross-origin rule punts to the system browser, so a tapped
 * in-app notification opens Safari instead of routing inside the app.
 *
 * Strip to pathname+search+hash so React Router stays in charge.
 * Malformed URLs are swallowed rather than crashing the click handler —
 * the row is already marked read by the caller; a no-op is acceptable.
 */
export function navigateToUrl(
  navigate: ReturnType<typeof useNavigate>,
  url: string,
): void {
  try {
    const u = new URL(url, window.location.origin);
    navigate(u.pathname + u.search + u.hash);
  } catch {
    // Server-supplied URL was malformed — ignore.
  }
}
